export const FORM = {
  REG: 'regForm',
  LOGIN: 'loginForm',
  VERIFICATION: '2faForm',
  RESTORE: 'restoreForm',
  CHANGE: 'changeForm',
  CONNECT: 'needPassForm',
  SAML: 'samlLoginForm',
  SOCIAL: 'socialLogin',
};

export const DESKTOP_MIN_WIDTH = '(min-width: 1200px)';
export const MOBILE_MAX_WIDTH = '(max-width: 768px)';
